//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/select_box'
import 'devextreme/ui/slider'

//#endregion

import { ROUTE_TRACKING_SERVICE_NAME } from '../../../../services/route'
import { $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'

import { RouteTrackingDirectiveController } from './routes-tracking.controller'
import { IMRBaseComponent } from '../../../common/base'

//#region Asset Imports

import './routes-tracking.scss'
import * as TEMPLATE from './routes-tracking.tpl.html'

//#endregion

// #region Setup

export class RouteTrackingComponent extends IMRBaseComponent {

    //#region Ctor

    constructor() {
        super({
            controller: RouteTrackingDirectiveController,
            services: [
                $SCOPE_SERVICE_NAME,
                $TIMEOUT_SERVICE_NAME,
                ROUTE_TRACKING_SERVICE_NAME,
                USER_SESSION_SERVICE_NAME,
            ],
            template: TEMPLATE
        })
    }

    //#endregion
}